<template>
  <div ref="wrapper" class="form-submit">
    <div
      class="form-submit__error"
      v-show="errorCount && !hasSubmitError"
    >{{ $t('errors.correct_red_fields') }}</div>
    <div
      class="form-submit__error"
      v-if="hasSubmitError"
    >{{ errorMessage || $t('errors.form_submit') }}</div>
    <div
      class="form-submit__success"
      v-show="submittedSuccessfully && successMessage"
    >{{ successMessage }}</div>
  </div>
</template>

<script>
/**
 * @file SubmitMessage
 * @author pierre-michel@on-running.com
 *
 * Component to display error or success messages following "submit-form" mixin standards.
 */

export default {
  name: 'SubmitMessage',

  props: {
    stopEditingHandler: {
      type: Function,
    },
    errorCount: {
      type: Number,
      required: true,
    },
    hasSubmitError: {
      type: Boolean,
      required: true,
    },
    submittedSuccessfully: {
      type: Boolean,
    },
    successMessage: {
      type: String,
    },
    errorMessage: {
      type: String,
    },
  },

  mounted() {
    if (!this.$parent.$refs.submitMessage) {
      throw 'ref="submitMessage" is missing on <SubmitMessage>'
    }
  },
}
</script>

<style scoped lang="scss">
.form-submit {
  opacity: 0;

  &--visible {
    opacity: 1;
    transition: opacity $transition-time-fast;
  }

  &__success,
  &__error {
    padding: #{$site-gutter + 5} 0 0;
    font-size: $font-size-normal;
    text-align: center;
  }

  &__success {
    color: $color-green;
  }

  &__error {
    color: $color-red;
  }
}
</style>
